import type { Translation } from "./strings";

// Neutral Spanish, for Spain and Latin America alike.
export default {
  history: "Historial de escucha",
  history_all_time: "Todo el tiempo",
  history_calendar: "Calendario",
  history_daily: "Historial de escucha diario de {noise}",
  history_back: "Volver a todos los sonidos",
  history_sound: "Sonido",
  history_all_time_empty: "Aún no hay escuchas registradas.",
  history_minutes: "Minutos reproducidos",
  history_date: "Fecha",
  history_previous: "Semana anterior",
  history_next: "Semana siguiente",
  history_today: "Hoy",
  history_empty: "No hay escuchas registradas para estas fechas.",
  history_local: "Guardado en este dispositivo. La escucha en curso se actualiza cada 15 segundos.",
  history_storage_failed: "No se pudo cargar o guardar parte del historial de escucha.",
  history_value: "{noise}: {minutes} min",

  widget_description: "Inicia y detén cada sonido con un toque.",
  noise_white_title: "Ruido blanco",
  noise_pink_title: "Ruido rosa",
  noise_brown_title: "Ruido marrón",
  noise_fan_title: "Ventilador",
  noise_waves_title: "Olas del mar",
  noise_white_short: "Blanco",
  noise_pink_short: "Rosa",
  noise_brown_short: "Marrón",
  noise_fan_short: "Ventilador",
  noise_waves_short: "Olas",
  noise_white_blurb: "La misma energía en todas las frecuencias. Brillante y nítido.",
  noise_pink_blurb: "Agudos más suaves, graves más profundos. Como una lluvia constante.",
  noise_brown_blurb: "Sobre todo graves, agudos apagados. Un rumor profundo y suave.",
  noise_fan_blurb: "Un flujo de aire constante sobre un zumbido grave.",
  noise_waves_blurb: "Olas que llegan y se retiran, nunca dos veces iguales.",
  status_audio_failed: "Este navegador no pudo iniciar el audio.",
  play_noise: "Reproducir {noise}",
  stop_noise: "Detener {noise}",
  stop: "Detener",
  language: "Idioma",
  language_device: "Idioma del dispositivo",
  language_storage_failed: "Este navegador no pudo guardar su idioma. Se restablecerá cuando cierre esta página.",
  volume: "Volumen",
  more: "Más",
  playback_log: "Registro de reproducción",
  playback_log_local: "Los últimos 300 eventos se guardan en este dispositivo. No se envía nada a menos que compartas el registro. Los detalles incluyen códigos de diagnóstico del sistema.",
  playback_log_empty: "Aún no se han registrado eventos de reproducción.",
  playback_log_storage_failed: "No se pudieron cargar o guardar algunos eventos de reproducción.",
  playback_log_share: "Compartir registro",
  playback_log_save: "Guardar registro",
  playback_log_share_failed: "No se pudo compartir el registro. Intenta guardarlo.",
  log_play_requested: "Reproducción solicitada",
  log_stop_requested: "Detención solicitada",
  log_started: "Reproducción iniciada",
  log_stopped: "Reproducción detenida",
  log_focus_changed: "Cambio de foco de audio",
  log_focus_denied: "Solicitud de foco de audio denegada",
  log_noisy: "Salida de audio desconectada",
  log_task_removed: "App eliminada de las recientes",
  log_engine_failed: "Fallo del motor de audio",
  log_service_destroyed: "Servicio de reproducción finalizado",
  log_process_exit: "El sistema registró el cierre del proceso durante la reproducción",
  log_unclean_exit: "La reproducción anterior no tiene una detención registrada; se desconoce la causa.",
  log_interruption: "Interrupción de la sesión de audio",
  log_route_changed: "Cambio de ruta de audio",
  log_configuration_changed: "Cambio de configuración del motor de audio",
  log_termination: "La app se está cerrando",
  log_context_state: "Cambio de estado del contexto de audio",
  log_worklet_error: "Fallo del worklet de audio",
  log_visibility: "Cambio de visibilidad de la página",
  log_page_hidden: "Página cerrada o abandonada",
  log_media_error: "Fallo de reproducción multimedia",
  settings: "Ajustes",
  settings_general: "General",
  appearance: "Apariencia",
  appearance_system: "Sistema",
  appearance_light: "Claro",
  appearance_dark: "Oscuro",
  appearance_storage_failed: "Este navegador no pudo guardar la apariencia. Se restablecerá cuando cierres esta página.",
  rate_app: "Valorar la app",
  about: "Acerca de",
  about_version: "Versión {version} ({build})",
  about_site_version: "Versión {version}",
  about_also_android_web: "También disponible en {android} y en {web}.",
  about_also_ios_web: "También disponible en {ios} y en {web}.",
  about_also_ios_android: "También disponible en {ios} y {android}.",
  platform_web: "la web",
  close: "Cerrar",
  notification_channel_name: "Reproducción",
  intent_noise: "Ruido",
  intent_play_title: "Reproducir ruido",
  intent_play_description: "Empieza a reproducir uno de los sonidos.",
  intent_stop_title: "Detener ruido",
  intent_stop_description: "Detiene la reproducción.",
  support: "Soporte",
  privacy_policy: "Política de privacidad",
  web_title: "Generador de ruido blanco, rosa y marrón",
  review_title: "Reproducción en segundo plano en Android",
  review_intro: "Esta grabación muestra cómo el audio iniciado por el usuario continúa mientras Noise Connoisseur está en segundo plano. Active el sonido para escuchar la reproducción.",
  review_start: "Toque «Play White Noise» (Reproducir ruido blanco) en la app.",
  review_background: "Vuelva a la pantalla de inicio y abra las notificaciones. El ruido blanco sigue sonando y los controles multimedia están visibles.",
  review_stop: "Toque «Pause» (Pausa) en la notificación. El audio se detiene; al volver a la app se muestra que la reproducción está detenida.",
  review_capture: "Grabado en un emulador de Android con un APK generado a partir del App Bundle de lanzamiento y firmado para pruebas locales. La grabación incluye el audio del dispositivo.",
  review_build: "Versión (compilación)",
  review_recorded: "Grabado",
  review_download: "Descargar video",
  review_details: "Detalles de la grabación",
} satisfies Translation;
